var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNextArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "",
    viewBox: "0 0 14 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M9.62422 7.5L5.24922 11.875L4.63672 11.2625L8.39922 7.5L4.63672 3.7375L5.24922 3.125L9.62422 7.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNextArrow);
export default __webpack_public_path__ + "static/media/ic-next-arrow.de8a82c320848e997daed059b3a2ed53.svg";
export { ForwardRef as ReactComponent };